import { defineStore } from 'pinia'

export const useSchoolUsersStore = defineStore('schoolUsersStore', {
  state: () => ({
    schoolUsers: [] as SchoolUser[],
  }),
  getters: {
    getSchoolUsers: (state) => {
      return () => state.schoolUsers
    },
  },
  actions: {
    addSchoolUsers(users: SchoolUser[]) {
      users.forEach((newUser: SchoolUser) => {
        if(!this.schoolUsers.find(existingUser => existingUser.userId === newUser.userId )){
          this.schoolUsers.push(newUser)
        }
      })
    },
    addSchoolUser(user: SchoolUser) {
      this.schoolUsers.push(user)
    },
    removeSchoolUser(user: SchoolUser) {
      this.schoolUsers = this.schoolUsers.filter((u) => u.userId !== user.userId)
    },
    deleteSchoolUsers() {
      this.schoolUsers = []
    }
  },
})
